module.exports = __webpack_public_path__ + "static/media/CBR-product-img@3x.b7ee9525.png";